(function () {
  function initSection(section) {
    if (section.dataset.tppBound) return;
    section.dataset.tppBound = '1';
    var track = section.querySelector('.custom-tpp__track');
    var prevBtn = section.querySelector('.custom-tpp__nav--prev');
    var nextBtn = section.querySelector('.custom-tpp__nav--next');
    if (!track || !prevBtn || !nextBtn) return;

    var scrollAmount = 300;

    function updateNav() {
      var scrollLeft = Math.round(track.scrollLeft);
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = scrollLeft <= 1;
      nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateNav, { passive: true });
    updateNav();

    /* Drag to scroll */
    var isDragging = false;
    var startX = 0;
    var scrollStart = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      isDragging = true;
      startX = e.clientX;
      scrollStart = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
      track.style.cursor = 'grabbing';
      track.style.scrollSnapType = 'none';
      track.style.userSelect = 'none';
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDragging) return;
      var dx = e.clientX - startX;
      track.scrollLeft = scrollStart - dx;
    });

    track.addEventListener('pointerup', function (e) {
      if (!isDragging) return;
      isDragging = false;
      track.releasePointerCapture(e.pointerId);
      track.style.cursor = '';
      track.style.scrollSnapType = '';
      track.style.userSelect = '';
    });

    track.addEventListener('pointercancel', function (e) {
      if (!isDragging) return;
      isDragging = false;
      track.releasePointerCapture(e.pointerId);
      track.style.cursor = '';
      track.style.scrollSnapType = '';
      track.style.userSelect = '';
    });

    /* Prevent click on links/buttons after drag */
    track.addEventListener('click', function (e) {
      if (Math.abs(track.scrollLeft - scrollStart) > 5) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  document.querySelectorAll('.custom-tpp').forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.custom-tpp');
    if (section) initSection(section);
  });
})();
